import React from 'react';

import { useAllPrismicDocumentsByType } from '@prismicio/react';
import { BlogTeaser, Box, Container, H1, Spinner } from 'react-components';

export const BlogPage: React.FunctionComponent = () => {
  const [documents] = useAllPrismicDocumentsByType('blog_post', {
    orderings: { field: 'my.blog_post.date', direction: 'desc' },
    graphQuery: `
    {
      blog_post {
        title
        image
        date
      }
    }
    `,
  });

  return (
    <Container minHeight="100vh">
      <Box>
        <Box>
          <H1 mt="9rem" mb={{ _: 5, sm: '6rem' }}>
            Blog
          </H1>
        </Box>

        {!documents && (
          <Box height="100%" display="flex" justifyContent="center" alignItems="center">
            <Spinner />
          </Box>
        )}

        <Box display="grid" gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr' }} gridGap={4} mb={6}>
          {documents?.map(
            (
              {
                data: {
                  title: [{ text: title }],
                  image: { url: imageSrc },
                  date,
                },
                url,
              },
              i
            ) =>
              url && (
                <BlogTeaser
                  key={i}
                  imageSrc={imageSrc}
                  title={title}
                  to={url}
                  date={new Date(date)}
                />
              )
          )}
        </Box>
      </Box>
    </Container>
  );
};
